import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
	alt: PropTypes.string,
	fallbackSource: PropTypes.string.isRequired,
	className: PropTypes.string,
	dataTestId: PropTypes.string,
	fetchPriority: PropTypes.oneOf(['auto', 'high', 'low']),
	isLazy: PropTypes.bool,
	sources: PropTypes.arrayOf(
		PropTypes.shape({
			srcSet: PropTypes.string.isRequired,
			type: PropTypes.string.isRequired,
		}),
	),
};

const defaultProps = {
	alt: '',
	className: '',
	dataTestId: 'fuse-picture-data-test-id',
	fetchPriority: undefined,
	isLazy: false,
	sources: undefined,
};

function Picture({
	className,
	dataTestId,
	sources,
	fallbackSource,
	isLazy,
	fetchPriority,
	alt,
	...props
}) {
	return (
		<div className={`fuse-picture ${className}`} data-testid={dataTestId} {...props}>
			{sources?.length > 0 ? (
				sources.map(({ srcSet }) => (
					// TODO: need to get the alt text for the images from CMS
					// eslint-disable-next-line jsx-a11y/alt-text
					<img
						className="fuse-picture__img"
						alt={alt}
						key={srcSet}
						src={srcSet}
						fetchpriority={fetchPriority}
						{...{ loading: isLazy ? 'lazy' : undefined }}
					/>
				))
			) : (
				<img
					className="fuse-picture__img"
					alt={alt}
					src={fallbackSource}
					fetchpriority={fetchPriority}
					{...{ loading: isLazy ? 'lazy' : undefined }}
				/>
			)}
		</div>
	);
}

Picture.propTypes = propTypes;
Picture.defaultProps = defaultProps;

export { Picture };

export default Picture;
